module.exports = __webpack_public_path__ + "static/media/gris_numero_de_casa.b13d46db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/gris_numero_de_casa.svg
// module id = 1751
// module chunks = 0